module.exports = __webpack_public_path__ + "img/ic-nav-classic--prev-circle-white.c1dfdfa8.svg";